import { UrlNames } from 'modules/app/constants';
import { configService } from 'modules/app/services';

export const getApiBaseUrl = (apiVersion: 'v1' | 'v2' | 'v3' = 'v2') =>
  apiVersion === 'v1'
    ? configService.getUrl(UrlNames.Api)
    : configService.getUrl(UrlNames.Api).replace('v1', apiVersion);
